module.exports = __webpack_public_path__ + "static/media/Banco Surinvest.8084c033.jpg";